import { useSuspenseQuery } from "@tanstack/react-query";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

export const useMetaAdsOverview = () =>
	useSuspenseQuery({
		queryKey: QueryKeys.Integrations.MetaAds.Overview(),
		queryFn: () => Api.GetMetaAdsOverview().then((r) => r.data),
	});
